import React, { useState, useRef } from 'react';
import { Button } from './button';
import { Icon } from './icon';
import { Popover } from './popover';
import { Menu, MenuItem } from './menu';

/*
    Popover-based select (dropdown).
    Children should be <option value="...">label</option> tags;
    they are rendered as MenuItems instead of a native <select>.
    For the native control use <Select />.
*/
export function SelectMenu({
  children = [],
  value,
  onChange,
  onClick,
  ...etc
}) {
  const [show, setShow] = useState(false);
  const pin = useRef(null);

  const childArr = Array.isArray(children) ? children : [children];

  const onButtonClick = (e) => {
    const haveOptions = childArr.some(
      (child) => child && child.type == 'option',
    );

    if (haveOptions) setShow(true);
    else if (onClick) onClick(e);
  };

  const onOptionClick = (e) => {
    onChange({
      target: {
        value: e.currentTarget.getAttribute('data-value'),
      },
      currentTarget: pin.current,
    });
  };

  const renderOption = (child) => {
    if (!child || child.type != 'option') return null;

    return (
      <MenuItem
        key={child.props.value}
        data-value={child.props.value}
        onClick={onOptionClick}
      >
        <Icon
          name={child.props.value == value ? 'check' : 'blank'}
        />
        {child.props.children}
      </MenuItem>
    );
  };

  //inside the button, render only the selected <option> label (+ non-option children)
  const renderChildren = (child) => {
    if (
      child &&
      child.type == 'option' &&
      child.props &&
      value != child.props.value
    )
      return null;

    if (child && child.type == 'option')
      return (
        <React.Fragment key={child.props.value}>
          {child.props.children}
        </React.Fragment>
      );

    return child;
  };

  return (
    <>
      <Button
        ref={pin}
        data-value={value}
        {...etc}
        onClick={onButtonClick}
      >
        {childArr.map(renderChildren)}
        <Icon name='arrow' />
      </Button>

      {show && (
        <Popover pin={pin} onClose={() => setShow(false)}>
          <Menu>{childArr.map(renderOption)}</Menu>
        </Popover>
      )}
    </>
  );
}
